import { useEffect, useState } from "react";
import useApi from "../../../Utilities/useAPI";
import { Checkbox } from "@mui/material";
import Snackbar from "@mui/material/Snackbar"; // Assuming you're using Material-UI for Snackbars

const GoogleContacts = ({ setSelectedContacts }) => {
  const { callApiFunction } = useApi();
  const [token, setToken] = useState(localStorage.getItem("g_token"));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedContacts, setSelectedContactsState] = useState([]); // Track selected contacts locally
  const [showError, setShowError] = useState(false);

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  useEffect(() => {
    callApiFunction("getGoogleContacts", { g_token: token })
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // 1. Display Snackbar
          setShowError(true);

          // 2. Remove token from localStorage
          localStorage.removeItem("g_token");
        } else {
          // Handle other errors
          setShowError(true);

          // 2. Remove token from localStorage
          localStorage.removeItem("g_token");
          console.error("API call failed:", error);
        }
        setLoading(false);
      });
  }, []);

  const handleCloseSnackbar = () => {
    setShowError(false);
  };

  const handleCheckboxChange = (contact) => {
    setSelectedContactsState((prevSelected) => {
      let updatedSelected;
      if (prevSelected.some((c) => c.name === contact.name)) {
        // If contact is already selected, remove it
        updatedSelected = prevSelected.filter((c) => c.name !== contact.name);
      } else {
        // Otherwise, add it to the selection
        updatedSelected = [...prevSelected, contact];
      }

      setSelectedContacts(updatedSelected); // Update the parent state

      return updatedSelected;
    });
  };

  if (loading) return <></>;

  return (
    <div className="import-google-contact">
      {data && data.contacts ? (
        <ul>
          <pre>
            {data.contacts.map((contact, index) => (
              <div
                key={index}
                className="d-flex flex-row justify-content-between border-bottom align-items-center"
              >
                <h6 className="text-center mb-0">{contact.name}</h6>
                <Checkbox
                  {...label}
                  checked={selectedContacts.some(
                    (c) => c.name === contact.name
                  )}
                  onChange={() => handleCheckboxChange(contact)}
                />
              </div>
            ))}
          </pre>
        </ul>
      ) : (
        <div className="my-3 pe-2">
          No Google Contacts Added! Head to your
          <a
            href="https://contacts.google.com/"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Google Contacts{" "}
          </a>
          and add some contacts to view them here.
        </div>
      )}

      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message="Authentication error. Please re-login."
      />
    </div>
  );
};

export default GoogleContacts;
